import React from 'react'
import './index.less'

export default class Footer extends React.Component{
    render (){
        return(
            <div className="footer-box">
                <a className="footer" href="http://www.jiangtour.com/">Site by:酱游科技  粤ICP备17047824号</a>
            </div>
        );
    }
}
